import React from 'react';
import PropTypes from 'prop-types';
import css from './FormGroup.module.scss';
import DeleteButton from "../../Button/DeleteButton.jsx";

const FormGroupOuterParent = ({
  title,
  className,
  children,
  onRemove,
}) => {
  return (
    <div className={`${className} ${css.formGroupOuterParent}`}>
      <div className={css.header}>
        {title && <h5 className={css.formGroupTitle}>{title}</h5>}
        {onRemove &&
          <DeleteButton onClick={onRemove}/>
        }
      </div>
      <div>
        {children}
      </div>
    </div>
  );
};

FormGroupOuterParent.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  onRemove: PropTypes.func,
  showRemove: PropTypes.bool
};

export default FormGroupOuterParent;
